var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "privacy",
      attrs: { visible: _vm.privacyVisible, width: "600px" },
      on: {
        "update:visible": function($event) {
          _vm.privacyVisible = $event
        },
        close: _vm.close
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title"
        },
        [
          _c("div", [
            _vm._v("云图梭隐私政策"),
            _c("small", [_vm._v("（20220322版）")])
          ])
        ]
      ),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", [_vm._v("最新更新日期：2022年3月21日")]),
          _c("div", [_vm._v("生效日期：2022年3月22日")])
        ]),
        _c("div", { staticClass: "wrap" }, [
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [_vm._v("前 言")]),
            _c("div", { staticClass: "content" }, [
              _c("p", [_c("em", [_vm._v("尊敬的用户")]), _vm._v("：")]),
              _c("p", { staticClass: "font" }, [
                _vm._v(
                  "“云图梭”（应用名称：云图梭，开发者：深圳须弥云图空间科技有限公司，联系地址：深圳市南山区粤海街道海珠社区滨海大道3369号有线信息传输大厦25F2504，以下或称“"
                ),
                _c("em", [_vm._v("我们")]),
                _vm._v(
                  "”）非常重视客户（“您”）个人信息及隐私权的保护，您在使用我们的产品或服务时，我们可能会收集、存储、使用您的相关信息，因此我们制订了涵盖如何收集、存储、使用、共享和保护客户信息的隐私政策（即 “本隐私政策”）。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "本隐私政策与您使用我们的服务和该等服务所包含的各项业务功能紧密相关，请仔细阅读本隐私政策的全部条款（尤其是以加粗方式显示的内容），确认您已完全了解我们对您个人信息的处理规则，并作出您认为适当的选择。阅读过程中，您若有任何疑问，可拨打我们的客服电话（400-608-9666）进行咨询。如您就本隐私政策或就我们对本隐私政策进行的更新（我们会及时提示您更新的情况）点击或勾选“同意”并确认提交，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "“云图梭提供的产品与/或服务”是指“云图梭”网络及技术服务提供者通过下述途径向您提供的产品与/或服务：包括但不限于“云图梭”等网站、客户端以及相关微信开放平台账号或小程序等。此外，针对某些特定的产品/服务，我们还将制定单独的隐私政策，向您说明这些产品/服务的特殊政策。如相关特定的隐私政策与本隐私政策有不一致之处，适用特定隐私政策。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "请您注意，本政策不适用于您通过我们的产品/服务而接入的其他第三方产品/服务(“其他第三方”，包括您的交易相对方、任何第三方网站以及第三方服务提供者等)，具体规定请参照该第三方的隐私政策或类似声明。"
                )
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [_vm._v("定 义")]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _c("em", [_vm._v("龙湖集团及旗下相关产品服务：")]),
                _vm._v(
                  "指龙湖集团控股有限公司（股份代码：960）及旗下公司，包括但不限于：地产开发、商业运营、租赁住房、空间服务、房屋租售、房屋装修、健康养老等公司提供的产品与服务。"
                )
              ]),
              _c("p", [
                _c("em", [_vm._v("个人信息：")]),
                _vm._v(
                  "指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定 自然人身份或者反映特定自然人活动情况的各种信息，如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产 信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。"
                )
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "敏感个人信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。通常情况下，14岁以下(含)儿童的个人信息和涉及自然人隐私的信息属于个人敏感信息。本隐私政策中涉及的“敏感个人信息”将以加粗方式显示，请您充分注意。"
                  )
                ])
              ]),
              _c("p", [
                _c("em", [_vm._v("个人信息删除：")]),
                _vm._v(
                  "指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。"
                )
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [_vm._v("目 录")]),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v("一、我们如何收集和使用您的个人信息")]),
              _c("p", [_vm._v("二、我们如何使用 Cookie 和同类技术")]),
              _c("p", [_vm._v("三、我们如何共享、转让、公开披露您的个人信息")]),
              _c("p", [_vm._v("四、我们如何保护和保存您的个人信息")]),
              _c("p", [_vm._v("五、您如何管理您的个人信息")]),
              _c("p", [_vm._v("六、未成年人个人信息保护")]),
              _c("p", [_vm._v("七、通知和修订")]),
              _c("p", [_vm._v("八、如何联系我们")])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("一、我们如何收集和使用您的个人信息")
            ]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "我们提供的业务功能需要依赖部分您提供的个人信息才得以运行，在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种："
                )
              ]),
              _c("p", [
                _vm._v(
                  "在您使用我们的产品与/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种："
                ),
                _c("br"),
                _c("em", [
                  _vm._v(
                    "1、为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务，我们的基本业务功能，包括注册用户服务、实现线上工作协同、实现信息搜索和展示功能；"
                  )
                ]),
                _c("br"),
                _c("em", [
                  _vm._v(
                    "2、为实现向您提供我们产品及/或服务的附加功能，您可针对每项附加功能单独选择授权或不授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。"
                  )
                ])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(" 您理解并同意："),
                  _c("br"),
                  _vm._v(
                    " 1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，相应地，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 2、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本隐私政策、以弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。"
                  ),
                  _c("br")
                ]),
                _vm._v(
                  " 在此过程中，如果您有任何疑问、意见或建议的，您可通过客服电话（400-608-9666）与我们联系，我们会尽快为您作出解答。 "
                )
              ]),
              _c("p", [
                _vm._v(
                  "我们仅会出于以下核心业务功能，收集和使用您的相关如下个人信息，我们的下述核心业务功能的实现依赖于您提供的如下相关个人信息，如果您不提供相关信息，您将无法享受我们提供的产品和/或服务："
                )
              ]),
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（一）帮助您成为我们的注册用户")])
              ]),
              _c("p", [_vm._v("1、基础用户服务")]),
              _c("p", [
                _vm._v(
                  "我们通过个人账户为您提供基础用户服务。为注册成为用户并使用我们的基础服务，您需要提供"
                ),
                _c("em", [_vm._v("手机号码")]),
                _vm._v("用于创建个人账户。")
              ]),
              _c("p", [
                _vm._v(
                  "对于需要通过个人账户才能使用的服务，我们可能会根据您提供的上述信息校验您的用户身份，确保我们是在为您本人提供服务。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "您使用个人账号初次登录时，您将会有初次授权验证环节，需要您授权同意我们调用您的"
                ),
                _c("em", [_vm._v("短信接收和处理")]),
                _vm._v("功能，向您发送短信以验证您的身份。")
              ]),
              _c("p", [_vm._v("2、附加用户服务")]),
              _c("p", [
                _vm._v(" 您可以根据所在组织的认证要求，提供相应的"),
                _c("em", [_vm._v("身份信息")]),
                _vm._v("（身份证、护照、户口本及其他身份证件信息）、"),
                _c("em", [_vm._v("生物识别特征（静态或动态的面部特征）")]),
                _vm._v("以完成"),
                _c("em", [_vm._v("实人认证")]),
                _vm._v(
                  "。若您要使用账户增强保护功能，除可选择完成上述实人认证外，您还可以选择开启声纹密保或者扫脸登录，提供"
                ),
                _c("em", [_vm._v("声纹")]),
                _vm._v("或者"),
                _c("em", [_vm._v("面部特征信息")]),
                _vm._v("。"),
                _c("br"),
                _vm._v(
                  " 此外，我们可能会根据您的授权从第三方处获取您的第三方账户信息，并与您的龙湖账户进行绑定，使您可通过第三方账户直接登录、使用我们的产品及/或服务。我们将在您授权同意的范围内使用您的相关信息。 "
                )
              ]),
              _c("p", [_vm._v("3、账户信息展示")]),
              _c("p", [
                _vm._v(
                  "如果您已拥有个人账户，我们可能会在账户显示您的上述个人信息，以及您在产品/服务中执行的操作。我们会尊重您对产品服务和账户设置所做的选择。"
                )
              ]),
              _c("p"),
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（二）实现线上工作协同必须的功能")])
              ]),
              _c("p"),
              _c("p", [_vm._v("1、工作任务信息展示")]),
              _c("p", [
                _vm._v(
                  "为了让您快速地找到您的工作任务等信息，我们可能会收集您使用我们的产品与/或服务的"
                ),
                _c("em", [
                  _vm._v(
                    "设备信息（包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、浏览器类型"
                  )
                ]),
                _vm._v(
                  "来为您提供信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。"
                )
              ]),
              _c("p", [_vm._v("2、即时沟通功能")]),
              _c("p", [
                _vm._v(
                  " 为保证新成员加入群组后可以快速融入团队和项目，即时沟通功能可随时随地查看成员所在对话的全部历史消息，同时我们将获取您的消息记录存储在云端服务器中，并会根据您的操作设置同步到相应设备。"
                ),
                _c("br"),
                _vm._v(" 当您发送语音信息时，我们需要调用系统"),
                _c("em", [_vm._v("麦克风（录音）权限")]),
                _vm._v(
                  "来完成收集您的语音信息。请您知晓，语音信息仅在您主动点击后开始收集，并仅发送给您指定的平台用户。"
                ),
                _c("br"),
                _vm._v(" 当您发送图片信息时，我们需要调用系统"),
                _c("em", [
                  _vm._v("相机（摄像头）权限或读取相册（读取外部存储）权限")
                ]),
                _vm._v(
                  "来进行收集您即时拍摄或相册中已有的图片。请您知晓，图片信息仅收集您主动拍摄的或相册中指定的对象，并仅发送给您指定的平台用户。 "
                )
              ]),
              _c("p", [_vm._v("3、线上会议功能")]),
              _c("p", [
                _vm._v("为了实现在平台内的音视频会议功能，您需要开启"),
                _c("em", [_vm._v("麦克风（录音）/相机（摄像头）权限")]),
                _vm._v(
                  "，在您已同意开启上述权限后，我们也仅会在您主动点击客户端内麦克风/摄像头图标时获取语音视频信息。"
                )
              ]),
              _c("p", [_vm._v("4、云文档功能")]),
              _c("p", [
                _vm._v(
                  "您可通过本平台的云文档功能，多人同时查看和编辑存储在云端的文档。为了使参与文档协同的用户清晰明确的知晓文档编辑信息，在您正在或已经发布文档内容时，我们将收集您发布的信息，并展示您的姓名、头像、发布内容。此外，您可根据不同的需求对文档可共享和编辑的范围进行设置。"
                )
              ]),
              _c("p", [_vm._v("5、日程功能")]),
              _c("p", [
                _vm._v(
                  "您可通过本平台的日程功能添加工作事件提醒，并发送会议邀请。我们将收集并同步您在平台中处理的日程相关沟通信息，以便在日程功能中展示，帮助您创建管理日程信息、安排任务及提醒您相关日程事项安排，例如当您选择接收、拒绝或待定会议邀请时，相应回复会在日程中标注。"
                )
              ]),
              _c("p"),
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（三）实现信息搜索和展示所必须的功能")])
              ]),
              _c("p", [
                _vm._v(
                  "在您使用我们服务过程中，为保障您的账号及系统运行安全、识别账户异常状态、了解产品适配性、向您提供更契合您需求的页面展示、改进和优化产品功能，我们可能会自动收集您的使用情况并存储为网络日志信息，包括："
                )
              ]),
              _c("p", [
                _vm._v(
                  "设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、设备环境、设备标识符（如"
                ),
                _c("em", [
                  _vm._v(
                    "IMEI/androidID/IDFA/OPENUDID/GUID/OAID、SIM卡IMSI、ICCID"
                  )
                ]),
                _vm._v("信息等）、设备"),
                _c("em", [_vm._v("MAC")]),
                _vm._v(
                  "地址、软件安装列表、电信运营商等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点和基站等传感器信息）。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、报验、提交问题、整改问题，以及IP地址、浏览器类型、电信运营商、访问日期和时间。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。"
                )
              ]),
              _c("p", [
                _vm._v(
                  " 为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和您使用龙湖集团产品/服务时的浏览使用信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息和可能的商业广告。当我们利用您的个人信息进行自动化决策时,会保证决策的透明度和处理结果的公平合理。当我们通过自动化决策方式进行商业营销、信息推送时,会同时提供不针对您个人特征的选项。您可以通过回复“TD”退订我们发送给您的营销短信，拒绝定向推送。"
                ),
                _c("br"),
                _vm._v(
                  " 我们努力保障您的使用体验和浏览体验。如果您不想接受我们通过自动化决策产生的展示、推送信息和可能的商业广告，您可通过系统设置或联系我们的客服指导您进行关闭。"
                ),
                _c("br"),
                _vm._v(
                  " 此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。 "
                )
              ]),
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [
                  _vm._v(
                    "（四）您可选择是否授权我们收集和使用您的个人信息的情形"
                  )
                ])
              ]),
              _c("p", [
                _vm._v(
                  " 1、为使您使用我们的服务更便捷，从而提升您的体验，我们的以下附加功能中可能会收集和使用您的个人信息。"
                ),
                _c("em", [
                  _vm._v(
                    "如果您不提供这些个人信息，您依然可以使用云图梭产品或服务中的核心功能，但您可能无法使用这些附加功能。"
                  )
                ]),
                _vm._v("这些附加功能包括："),
                _c("br"),
                _vm._v(" （1）基于"),
                _c("em", [_vm._v("相机（摄像头）权限")]),
                _vm._v(
                  "的附加功能：当您在问题沟通或问题整改时，您可能会对出现问题或者需要报验的部位进行拍照或者拍摄，此时您可以通过开通"
                ),
                _c("em", [_vm._v("相机（摄像头）权限")]),
                _vm._v("以便拍照或拍摄；"),
                _c("br"),
                _vm._v(" （2）基于"),
                _c("em", [_vm._v("读取相册（读取外部存储）权限")]),
                _vm._v(
                  "的附加功能：通过该功能，您可以在平台中上传您相册的照片作为您的头像；"
                ),
                _c("br"),
                _vm._v(" （3）基于"),
                _c("em", [_vm._v("写入相册（写入外部存储）权限")]),
                _vm._v(
                  "的附加功能：您可以通过该功能将平台中的图片信息存储于本地相册，以方便日常查看；"
                ),
                _c("br"),
                _vm._v(" （4）基于"),
                _c("em", [_vm._v("位置权限")]),
                _vm._v(
                  "的附加功能：我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，来实现工作打卡功能；"
                ),
                _c("br"),
                _vm._v(" （5）基于"),
                _c("em", [_vm._v("写入通讯录权限")]),
                _vm._v(
                  "的附加功能：通过该项功能您可将应用中的信息写入到您的通讯录中，以方便您不需再手动输入；"
                ),
                _c("br"),
                _vm._v(" （6）基于"),
                _c("em", [_vm._v("拨打电话权限")]),
                _vm._v(
                  "的附加功能：基于该权限的功能，将方便您可以直接在App内拨打相应号码而无需退出至手机桌面；"
                ),
                _c("br"),
                _vm._v(" （7）基于"),
                _c("em", [_vm._v("日历权限")]),
                _vm._v(
                  "的附加功能：基于该权限的功能，将方便您将应用中的日程和会议信息写入手机的日历提醒中。 "
                )
              ]),
              _c("p", [
                _vm._v("2、上述附加功能可能需要您在您的设备中向我们开启您的"),
                _c("em", [
                  _vm._v(
                    "相机（摄像头）、读写相册（读写外部存储）、位置、通讯录、拨打电话、日历"
                  )
                ]),
                _vm._v("等访问权限，"),
                _c("em", [_vm._v("以实现这些功能所涉及的信息的收集和使用")]),
                _vm._v(
                  "。您可以通过“系统的设置->应用管理->权限管理”中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。"
                ),
                _c("em", [
                  _vm._v(
                    "请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。"
                  )
                ])
              ]),
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [
                  _vm._v(
                    "（五）您充分知悉，以下情形中，我们收集、使用个人信息可能无需征得您的授权同意："
                  )
                ])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(" 1、与国家安全、国防安全直接相关的；"),
                  _c("br"),
                  _vm._v(" 2、与公共安全、公共卫生、重大公共利益直接相关的；"),
                  _c("br"),
                  _vm._v(" 3、与犯罪侦查、起诉、审判和判决执行等直接相关的；"),
                  _c("br"),
                  _vm._v(
                    " 4、出于维护个人的生命、财产等重大合法权益但又很难得到本人同意的；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 5、所收集的个人信息是个人信息主体或其监护人自行向社会公众公开的；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；"
                  ),
                  _c("br"),
                  _vm._v(" 7、根据您的要求签订和履行合同所必需的；"),
                  _c("br"),
                  _vm._v(
                    " 8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；"
                  ),
                  _c("br"),
                  _vm._v(" 9、为合法的新闻报道所必须的"),
                  _c("br"),
                  _vm._v(
                    " 10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；"
                  ),
                  _c("br"),
                  _vm._v(" 11、法律法规规定的其他情形。 ")
                ]),
                _vm._v(" 请知悉，根据适用的法律，"),
                _c("em", [
                  _vm._v(
                    "若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，"
                  )
                ]),
                _vm._v(
                  "或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善云图梭的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），"
                ),
                _c("em", [
                  _vm._v(
                    "则此类处理后数据的使用无需另行向您通知并征得您的同意。"
                  )
                ])
              ]),
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（六）您个人信息使用的规则")])
              ]),
              _c("p", [
                _vm._v(
                  " 1、我们会根据本隐私政策的约定，在实现我们的产品与/或服务功能所必要的范围内，对所收集的个人信息进行使用。"
                ),
                _c("br"),
                _vm._v(
                  " 2、在收集您的个人信息后，我们可能将通过技术手段对部分数据进行匿名化处理，匿名化处理的信息将无法识别主体。"
                ),
                _c("em", [
                  _vm._v(
                    "请您了解并同意，在此情况下我们有权使用已经匿名化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。"
                  )
                ]),
                _c("br"),
                _vm._v(" 3、"),
                _c("em", [
                  _vm._v(
                    "请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除、通过系统设置或联系我们等方式撤回您的同意，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账户时，我们将停止使用并删除您的个人信息。"
                  )
                ]),
                _c("br"),
                _vm._v(
                  " 4、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。"
                ),
                _c("br"),
                _vm._v(
                  " 5、当我们展示您的个人信息时，我们会采用包括内容替换、去标识化处理等方式对您的信息进行脱敏，以保护您的信息安全。"
                ),
                _c("br"),
                _vm._v(
                  " 6、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会要求您通过主动勾选的形式事先征求您的同意。 "
                )
              ]),
              _c("p")
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _c("em", [_vm._v("二、我们如何使用Cookie和同类技术")])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "1、为实现您的个性化需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies 是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的偏好或您浏览历史等数据进而为您提供偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "2、我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有 Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookies；您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。"
                )
              ]),
              _c("p", [
                _vm._v(" 3、Cookie同类技术"),
                _c("br"),
                _vm._v(
                  " 除 Cookie外，我们还会在云图梭上使用网站信标、像素标签、ETag等其他同类技术。"
                ),
                _c("br"),
                _vm._v(
                  " 例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。"
                ),
                _c("br"),
                _vm._v(
                  " ETag（实体标签）是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie。ETag可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过ETag来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。但请注意，如果停用ETag，您可能无法享受相对更佳的产品或服务体验。"
                ),
                _c("br")
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _c("em", [_vm._v("三、我们如何共享、转让、公开披露您的个人信息")])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（一）共享")])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "1、我们不会与龙湖集团以外的任何公司、组织和个人共享您的个人信息，但以下情况除外："
                  )
                ])
              ]),
              _c("div", [
                _c("em", [_vm._v("（1）事先获得您明确的同意或授权；")])
              ]),
              _c("div", [
                _c("em", [_vm._v("（2）与国家安全、国防安全直接相关的；")])
              ]),
              _c("div", [
                _c("em", [
                  _vm._v("（3）与公共安全、公共卫生、重大公共利益直接相关的；")
                ])
              ]),
              _c("div", [
                _c("em", [
                  _vm._v("（4）与犯罪侦查、起诉、审判和判决执行等直接相关的；")
                ])
              ]),
              _c("div", [
                _c("em", [
                  _vm._v(
                    "（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
                  )
                ])
              ]),
              _c("div", [
                _c("em", [_vm._v("（6）自行向社会公众公开的个人信息；")])
              ]),
              _c("div", [
                _c("em", [
                  _vm._v(
                    "（7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"
                  )
                ])
              ]),
              _c("div", [
                _c("em", [
                  _vm._v(
                    "（8）基于法定情形下：根据法律法规的规定、诉讼争议解决需要，或行政、司法等有权机关依法提出的要求；"
                  )
                ])
              ]),
              _c("div", [
                _c("em", [
                  _vm._v(
                    "（9）在您主动选择情况下共享：您通过云图梭购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。"
                  )
                ])
              ]),
              _c("p"),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "2、在您授权的情况下，我们可能会将您的个人信息与我们的关联方共享，我们只会共享必要的个人信息，并要求关联方以不低于本隐私政策水平的方式保护您的个人信息。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。就上述关联方向您提供的服务，我们对该等关联方提供的服务性质与质量不作任何承诺或承担任何责任，对该等关联方独立进行的用户信息采集和处理行为也不作任何承诺或承担任何责任。有关您在使用关联方服务中相关的隐私控制和选项，以及服务提供者的隐私规定，请您谨慎参阅该等关联方所提供的隐私政策。"
                  )
                ])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "3、我们可能会向合作伙伴等第三方共享您的部分个人信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。"
                  )
                ]),
                _vm._v(
                  "除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名、手机号或电子邮箱，通过这些信息可以联系到您或识别您的身份）与合作伙伴分享。我们可能会向这些合作伙伴提供经过匿名化处理的信息，用于运营分析，匿名性会确保相关信息不会识别您个人。"
                )
              ]),
              _c("p", [
                _vm._v(
                  " 与合作伙伴分享：我们可能会向合作伙伴共享为您提供服务所必要的订单信息、账户信息、支付信息、收货地址及联系人方式等。我们的合作伙伴包括以下类型："
                ),
                _c("br"),
                _c("em", [_vm._v("供应商\\服务提供商。")]),
                _vm._v(
                  "仅为实现本隐私政策中声明的目的，我们的某些服务将由合作伙伴提供。以保障为您提供的服务顺利完成，我们可能会将您的个人信息共享给上述合作伙伴，包括配送业务、技术服务、支付服务、金融业务等。其中可能包括您的联络信息、订单信息、支付信息、地址信息等，以保障为您提供的服务顺利完成。"
                ),
                _c("br"),
                _c("em", [_vm._v("第三方商家。")]),
                _vm._v(
                  "您通过云图梭平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易及服务有关的必要信息与提供相关商品或服务的第三方商家共享，以便其向您提供商品、服务及售后等。"
                ),
                _c("br"),
                _c("em", [_vm._v("其他业务合作伙伴。")]),
                _vm._v(
                  "我们还可能与委托我们进行推广和广告投放的合作伙伴共享信息，但我们仅会向这些合作伙伴提供推广的覆盖面、有效性以及统计类等信息，而不会提供可以识别您身份的个人信息。 "
                )
              ]),
              _c("p", [
                _vm._v(
                  "4、对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。"
                )
              ]),
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（二）转让与公开披露")])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "我们收集的信息将被视作一项资产。如果所属部门或部分资产被另一家公司收购，则此类信息可能成为被转让资产之一。在涉及此种情况时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。"
                  )
                ])
              ]),
              _c("p", [
                _vm._v(
                  "除本隐私政策所明确述明的情况以外，我们不会将您的个人信息转让或公开披露给任何公司、组织和个人，但以下情况除外： "
                )
              ]),
              _c("div", [_vm._v("1、与国家安全、国防安全直接相关的；")]),
              _c("div", [
                _vm._v("2、与公共安全、公共卫生、重大公共利益直接相关的；")
              ]),
              _c("div", [
                _vm._v("3、与犯罪侦查、起诉、审判和判决执行等直接相关的；")
              ]),
              _c("div", [
                _vm._v(
                  "4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
                )
              ]),
              _c("div", [_vm._v("5、您向社会公众公开的个人信息；")]),
              _c("div", [
                _vm._v(
                  "6、从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道；"
                )
              ]),
              _c("div", [
                _vm._v(
                  "7、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；"
                )
              ]),
              _c("div", [
                _vm._v(
                  "8、在云图梭服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。"
                )
              ]),
              _c("p"),
              _c("div", { staticClass: "sub-title" }, [
                _vm._v("（三）关于第三方插件管理")
              ]),
              _c("p", [
                _vm._v(
                  "为了给您提供更专业、安全的核心业务功能和附加业务功能，我们的产品中会接入第三方插件产品（包括在我们的网页或应用程序中部署统计分析工具、软件开发工具包SDK、调用地图API接口）。我们使用的第三方插件及个人信息收集详细情况请见本隐私政策附件1。"
                )
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _c("em", [_vm._v("四、我们如何保护和保存您的个人信息")])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（一）我们保护您个人信息的技术与措施")])
              ]),
              _c("p", [
                _vm._v(
                  "我们非常重视个人信息安全，并采取一切合理可行的措施，保护个人信息："
                )
              ]),
              _c("p", [_vm._v("1、数据安全技术措施")]),
              _c("p", [
                _vm._v(
                  "我们采取安全技术和管理措施来防止您的个人信息遭到未经授权访问使用、公开披露、使用、修改、损坏或丢失，包括但不限于："
                ),
                _c("br"),
                _vm._v(
                  " （1）我们采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换在内多种数据脱敏技术增强个人信息在使用中安全性；"
                ),
                _c("br"),
                _vm._v(
                  " （2）我们采取严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用；"
                ),
                _c("br"),
                _vm._v(
                  " （3）我们采取数据访问日志分析技术进行个人信息安全审计。 "
                )
              ]),
              _c("p", [
                _vm._v("2、我们为保护个人信息采取的其他安全措施"),
                _c("br"),
                _vm._v(
                  " （1）安全制度保障。龙湖集团发布了《数据安全管理制度》和《个人信息安全保护指引》，通过制度规范龙湖员工对个人信息所采取的管理措施。"
                ),
                _c("br"),
                _vm._v(
                  " （2）加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。 "
                )
              ]),
              _c("p", [
                _vm._v(
                  "3、我们建议您使用电子邮件、即时通讯、社交软件等与其他用户的交流工具时请使用复杂密码，并注意保护您的个人信息安全。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "4、我们将尽力确保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。"
                )
              ]),
              _c("p", [
                _vm._v("5、安全事件处置"),
                _c("br"),
                _vm._v(
                  " （1）为应对个人信息泄露、损毁和丢失的风险，我们制定了多项制度并成立了应急响应团队。我们按照安全事件的处置规范，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。"
                ),
                _c("br"),
                _vm._v(
                  " （2）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 "
                )
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "6、如果您发现自己的个人信息泄密或我们存在有安全弱点、可疑安全事件时，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策最下方约定的联系方式联络我们，以便我们采取相应措施，禁止私自尝试或验证弱点。"
                  )
                ])
              ]),
              _c("p", [
                _vm._v(
                  "7、如果您对我们的个人信息保护有任何疑问，可通过本隐私政策最下方约定的联系方式联系我们。"
                )
              ])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "sub-title" }, [
                _c("em", [_vm._v("（二）您个人信息的保存")])
              ]),
              _c("p", [
                _vm._v("1、您的个人信息将会被存储于中华人民共和国境内。")
              ]),
              _c("p", [
                _vm._v(
                  "2、在您使用我们的产品/服务期间，您的个人信息将在为了实现本隐私政策所述目的之期限内保存，同时将结合法律有强制的留存期限要求的规定确定，如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在超出保存期限后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "3、当您成功注销个人账户后，我们将在审核通过后对您的个人信息进行删除或匿名化处理。"
                )
              ]),
              _c("p", [
                _vm._v("4、"),
                _c("em", [
                  _vm._v(
                    "如果我们终止服务或运营，我们会至少提前30日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。"
                  )
                ])
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _c("em", [_vm._v("五、您如何管理您的个人信息")])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "我们非常重视您对个人信息的关注，并尽力保护您对于您个人信息"
                ),
                _c("em", [_vm._v("访问、更正、删除以及撤回同意")]),
                _vm._v(
                  "的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括："
                )
              ]),
              _c("p", [_c("em", [_vm._v("1、访问和更正您的个人信息")])]),
              _c("p", [
                _vm._v(
                  " 除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括："
                ),
                _c("br"),
                _vm._v(
                  " （1）您的账户信息：您可以访问、更正您账户中的个人资料及账号信息（身份认证信息除外）、支付信息、账号绑定信息等，也可以更改您的密码，您可以通过访问App在设置中执行此类操作。"
                ),
                _c("br"),
                _vm._v(
                  " （2）对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。"
                ),
                _c("br"),
                _vm._v(
                  " （3）您无法访问和更正的个人信息：除上述列明的信息外，您的部分个人信息我们还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用附加功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问和更正，但您可拨打我们的客服电话（400-608-9666）联系我们进行删除或做匿名化处理。 "
                )
              ]),
              _c("p", [_c("em", [_vm._v("2、删除您的个人信息")])]),
              _c("p", [
                _vm._v(
                  "您在我们的产品与/或服务页面中可以直接清除或删除的信息包括:"
                )
              ]),
              _c("p", [
                _vm._v("在以下情形中，您可以向我们提出删除个人信息的请求："),
                _c("br"),
                _vm._v(" （1）如果我们处理个人信息的行为违反法律法规；"),
                _c("br"),
                _vm._v(
                  " （2）如果我们收集、使用您的个人信息，却未征得您的同意；"
                ),
                _c("br"),
                _vm._v(" （3）如果我们处理个人信息的行为违反了与您的约定；"),
                _c("br"),
                _vm._v(" （4）如果您注销了账户；"),
                _c("br"),
                _vm._v(" （5）如果我们终止服务及运营。")
              ]),
              _c("p", [
                _vm._v(
                  "若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。"
                )
              ]),
              _c("p", [
                _c("em", [_vm._v("3、改变您授权同意的范围或撤回您的授权")])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "您可以通过删除信息、关闭设备功能、在云图梭网站或软件中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。"
                  )
                ])
              ]),
              _c("p", [_c("em", [_vm._v("4、注销账户")])]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "您可以拨打我们的管理员电话与我们联系，经核实您的注销信息、您所提供的信息甄别后，我们会在15个工作日内对您的注销账号申请完成处理。您注销成功后，我们将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。"
                  )
                ])
              ]),
              _c("p", [
                _vm._v(
                  "如果您无法通过上述方式访问、更正或删除您的个人信息以及注销账号，或者如果您认为“云图梭”存在违反法律的规定收集、使用您个人信息的情形，您可以通过我们的客服或通过本隐私政策提供的其他方式与我们取得联系。为了保障安全，我们可能需要您提供相应方式证明您的身份和请求的正当性，我们将在收到您反馈并验证您的身份后及时答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。"
                )
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _c("em", [_vm._v("六、未成年人个人信息保护")])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _c("em", [
                  _vm._v(
                    "1、我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。"
                  )
                ])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "2、我们不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。"
                  )
                ])
              ]),
              _c("p", [
                _c("em", [
                  _vm._v(
                    "3、如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。"
                  )
                ])
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _c("em", [_vm._v("七、通知和修订")])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "1、为给您提供更好的服务以及随着龙湖集团业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在云图梭网站、App或小程序上发出更新版本并在生效前通过公告或以其他适当方式提醒您相关内容的更新，也请您访问云图梭或龙湖集团网站以便及时了解最新的隐私政策。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。"
                )
              ]),
              _c("p", [
                _c("em", [_vm._v("本隐私政策所指的重大变更包括但不限于：")]),
                _c("br"),
                _c("em", [
                  _vm._v(
                    " （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；"
                  ),
                  _c("br"),
                  _vm._v(
                    " （2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；"
                  ),
                  _c("br"),
                  _vm._v(
                    " （3）个人信息共享、转让或公开披露的主要对象发生变化；"
                  ),
                  _c("br"),
                  _vm._v(
                    " （4）您参与个人信息处理方面的权利及其行使方式发生重大变化；"
                  ),
                  _c("br"),
                  _vm._v(
                    " （5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；"
                  ),
                  _c("br"),
                  _vm._v(" （6）个人信息安全影响评估报告表明存在高风险时。 ")
                ])
              ])
            ])
          ]),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "title" }, [
              _c("em", [_vm._v("八、如何联系我们")])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请拨打我们的客服电话：400-608-9666与我们联系。"
                )
              ]),
              _c("p", [
                _vm._v(
                  "2、一般情况下，我们将在15个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及市场监督管理等监管部门进行投诉或举报，或者向有管辖权的法院提起诉讼。"
                )
              ])
            ])
          ]),
          _c("br"),
          _c("section", { staticClass: "contents" }, [
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _c("em", [
                  _vm._v(
                    "我们谨此再次提醒您，本隐私政策内容中以加粗方式显著标识的条款，请您着重阅读。如您不同意隐私协议中的条款约定，请您停止使用我们的产品/服务。如您阅读并点击同意隐私协议，并按照流程完成注册申请，即表示您已充分阅读并接受协议全部内容；并表明您同意我们根据隐私协议内容处理您的个人信息。如您对隐私协议内容有任何疑问，您可随时与我们联系。"
                  )
                ])
              ])
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "docs" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("附件1")]),
            _c("div", { staticClass: "sub-title center" }, [
              _vm._v("《第三方插件使用情况说明》")
            ]),
            _c("p", [
              _vm._v(
                " 不同版本的云图梭应用所使用第三方插件会有所不同，一般包括基本功能类、第三方账号登录类、推送通知类、第三方支付类、地图导航类、分享类、统计类、安全风控类等。我们会对这些第三方插件进行严格的安全监测，以保障使用过程中的数据安全。您可以通过以下第三方插件链接，查看其数据使用和保护规则："
              )
            ]),
            _c("div", { staticClass: "split-line" }),
            _c(
              "el-table",
              { attrs: { data: _vm.pluginList, border: "", stripe: "" } },
              [
                _c("el-table-column", {
                  attrs: { prop: "type", label: "功能类型", "min-width": "100" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "aim", label: "使用目的", "min-width": "130" }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: "所属第三方名称",
                    "min-width": "80"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "privarys",
                    label: "涉及个人信息",
                    "min-width": "120"
                  }
                }),
                _c("el-table-column", {
                  attrs: { label: "官方链接", "min-width": "130" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              attrs: {
                                href: scope.row.link,
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [_vm._v(_vm._s(scope.row.link))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }